//src/services/medicineReturnService.js
import apiClient from "./apiClient";

// Return medicine to inventory
// Uses organization-specific {orgId}_medicine_inventory and {orgId}_medicine_transactions tables
// apiClient automatically adds organizationId as query parameter
export const returnMedicineToInventory = async (returnData) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    // Backend will:
    // 1. Update {orgId}_medicine_inventory (add quantity back)
    // 2. Create transaction in {orgId}_medicine_transactions
    const response = await apiClient.post(`/medicine-transactions/return`, returnData);
    return response.data;
  } catch (error) {
    console.error('Error returning medicine to inventory:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

// Get medicine return history
// Fetches from organization-specific {orgId}_medicine_transactions table
export const getMedicineReturnHistory = async (filters = {}) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const params = {};
    if (filters.patientId) params.patientId = filters.patientId;
    if (filters.medicineId) params.medicineId = filters.medicineId;
    if (filters.fromDate) params.fromDate = filters.fromDate;
    if (filters.toDate) params.toDate = filters.toDate;
    if (filters.returnType) params.returnType = filters.returnType;
    
    const response = await apiClient.get(`/medicine-returns`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching medicine return history:', error);
    throw error;
  }
};

// Get return history by patient ID
// Fetches from organization-specific {orgId}_medicine_transactions table
export const getReturnHistoryByPatientId = async (patientId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`/medicine-returns/patient/${patientId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching return history by patient ID:', error);
    throw error;
  }
};

// Get return history by treatment ID
// Fetches from organization-specific {orgId}_medicine_transactions table
export const getReturnHistoryByTreatmentId = async (treatmentId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`/medicine-returns/treatment/${treatmentId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching return history by treatment ID:', error);
    throw error;
  }
};

// Update medicine inventory after return
// Updates organization-specific {orgId}_medicine_inventory table
export const updateInventoryAfterReturn = async (inventoryData) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.post(`/medicine-inventory/return`, inventoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating inventory after return:', error);
    throw error;
  }
};

// Validate return quantity
// Validates against organization-specific {orgId}_patient_medicine_inventory table
export const validateReturnQuantity = async (medicineId, returnQuantity) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.post(`/medicine-returns/validate`, {
      medicineId,
      returnQuantity
    });
    return response.data;
  } catch (error) {
    console.error('Error validating return quantity:', error);
    throw error;
  }
};
